// extracted by mini-css-extract-plugin
export default {"playersContainer":"Players_playersContainer__mUjAH"};